// extracted by mini-css-extract-plugin
export default {"footerAds":"FooterAds_footerAds__R74sf"};